import type { Article } from "@/model/backend/article"
import type { ArticleVariation } from "@/model/backend/article-variation"
import type { Coupon } from "@/model/coupon/coupon"
import type { Customer } from "@/model/backend/customer"
import type { PageElement } from "@/model/backend/page-element"
import { type AppConfig, useAppConfig } from "@/vf"
import type { Terpene } from "@/model/backend/terpene"

export type ShippingMethod = {
    name: string
    prices: Record<string, number>
    subtitle: string
    title: string
    options: {
        title: string
        subtitle: string
        name: string
        price: number
    }[]
}

export type SupportedInfo = "gender" | "eventAnswer" | "acknowledgeCanG" | "etiquetteAccepted"

export interface AppConfigArticleVariation extends ArticleVariation {
    childArticle: AppConfigArticle
}

export interface AppConfigArticle extends Article {
    showLowStockWarning: boolean
    price: number
    allow: boolean
    isVariationArticle: boolean
    variations: AppConfigArticleVariation[]
    isShowcasePromoted: boolean
    colorCategory: string
    isPreparedType: boolean
}

export interface ShopAppConfig {
    showPrices: boolean
    requestUserInfos?: SupportedInfo[]
    tooManyOrdersWarning: boolean
    articlesRequireLogin: boolean
    offline: boolean
    offlineTitle: string
    offlineText: string
    searchTerms: string[]
    articles: AppConfigArticle[]
    user: Customer
    shippingMethods: ShippingMethod[]
    payment: {
        name: string
        subtitle: string
        title: string
    }[]
    startPageArticles: Article[]
    startPageFeatured: Required<PageElement> & { visible: boolean }
    hasBlogPosts: boolean
    customAfterLoginDialog?: {
        text: string
        presetImageIndex: number
    }
    customEnterShopDialog?: {
        text: string
        presetImageIndex: number
    }
    terpeneDescriptions: Record<string, Terpene>
    availableArticleTypes: string[]
    allowedUploadMimes: string[]
    allowedUploadExtensions: string[]
    jobOfferCount: number
    unreadBlogPostCount: number
    coupons: Coupon[]
}

export function useShopAppConfig() {
    return useAppConfig<AppConfig & ShopAppConfig>()
}
